import chatSlice from './slice'
import * as thunks from './thunks'

export default Object.assign(chatSlice, {
  thunks,
})
